export default __webpack_public_path__ + "static/media/english-to-norwegian-mobile-1.f3327a7d.png";